import { format } from "date-fns";

export const formatDate = (date: string | null | undefined): string => {
  return date ? format(new Date(date), "MM-dd-yyyy") : "";
};

export const formatDate2 = (date: string | null | undefined): string => {
  return date ? format(new Date(date), "yyyy-MM-dd") : "";
};

export const parseJwt = (token: string) => {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`;
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
};
